import { render, staticRenderFns } from "./TaskRecord.vue?vue&type=template&id=31eae2f6&scoped=true&"
import script from "./TaskRecord.vue?vue&type=script&lang=js&"
export * from "./TaskRecord.vue?vue&type=script&lang=js&"
import style0 from "./TaskRecord.vue?vue&type=style&index=0&id=31eae2f6&prod&scoped=true&lang=css&"
import style1 from "./TaskRecord.vue?vue&type=style&index=1&id=31eae2f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eae2f6",
  null
  
)

export default component.exports